export const deviceSettings = {
  speaker: { name: null, value: null },
  microphone: { name: null, value: null },
  camera: { name: null, value: null },
  userCameraInverted: false,
}

export const notificationSettings = {
  // if localStorage value is null, default value is true
  peerJoined: localStorage.getItem('notificationSetting_peerJoined') !== 'false',
  peerLeave: localStorage.getItem('notificationSetting_peerLeave') !== 'false',
  newMessage: localStorage.getItem('notificationSetting_newMessage') !== 'false',
  error: localStorage.getItem('notificationSetting_error') !== 'false',
}

export function getUsersPreferedSettings() {
  const { camera, microphone, speaker, userCameraInverted } = deviceSettings;

  // Start with default settings

  const settings = {
    audio: true, video: {
      width: { ideal: 640 },
      height: { ideal: 480 },
      frameRate: { ideal: 30, max: 30 },
    },
  };

  // Configure video if camera is set
  if (camera.name && camera.value) {
    settings.video = { deviceId: { exact: camera.value } };
  }

  // Configure audio if microphone is set
  if (microphone.name && microphone.value) {
    settings.audio = { deviceId: { exact: microphone.value }, echoCancellation: true };
  }

  // Add speaker and userCameraInverted regardless of configuration
  if (speaker.name && speaker.value) {
    settings.speaker = speaker;
  }
  settings.userCameraInverted = userCameraInverted;

  return settings;
}
